export function getApiErrorMessage(error: unknown, fallback = 'Something went wrong.'): string {
  const body = extractErrorBody(error);

  if (body === null || body === undefined) {
    return fallback;
  }

  if (Array.isArray(body.errors) && body.errors.length) {
    return body.errors
      .map(normalizeErrorItem)
      .filter((message) => message.length > 0)
      .join('\n');
  }

  if (typeof body.error === 'string' && body.error.trim()) {
    return body.error.trim();
  }

  if (typeof body.message === 'string' && body.message.trim()) {
    return body.message.trim();
  }

  if (typeof body === 'string' && body.trim()) {
    return body.trim();
  }

  return fallback;
}

function extractErrorBody(error: unknown): any {
  if (error === null || error === undefined) {
    return null;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (typeof error !== 'object') {
    return null;
  }

  const httpError = error as { error?: unknown; message?: string };

  if (httpError.error !== undefined && httpError.error !== null) {
    return httpError.error;
  }

  return httpError;
}

function normalizeErrorItem(item: unknown): string {
  if (typeof item === 'string') {
    return item.trim();
  }

  if (item && typeof item === 'object') {
    const record = item as { message?: unknown; error?: unknown };
    if (typeof record.message === 'string') {
      return record.message.trim();
    }
    if (typeof record.error === 'string') {
      return record.error.trim();
    }
  }

  return String(item ?? '').trim();
}
